import {
    IonIcon,
    useIonActionSheet,
    IonNote,
    IonBadge,
    IonButton
} from '@ionic/react';
import {
    Row,
    Col
} from 'reactstrap';
import { getMode } from '@ionic/core';
import {
    ellipsisHorizontalSharp,
    ellipsisVerticalSharp,
    trash,
    close,
    send,
    mail,
    cloudDownload,
    eye,
    chevronDownCircleOutline,
    chevronUpCircleOutline,
    pencil
 } from 'ionicons/icons';
import { useEffect, useState } from 'react';
import { OCCUPANT_TYPE, colorTheme } from '../../utils/constants';
import { Capacitor } from '@capacitor/core';

// All actions
const A_VIEW = 'View';
const A_EDIT = 'Edit';
const A_CANCEL = 'Cancel';
const A_DELETE = 'Delete';
const A_SEND = 'Send Invoice';
const A_DOWNLOAD = 'Download Invoice';


const InvoiceListItem = ({
    invoiceId, tenantName, amount, unitName, propertyName,
    currency, invoiceDate, showDetails, invoice, handleInvoiceAction,
    userAllPerms, options
 }) => {

    const [showExtraDetails, setShowExtraDetails] = useState(false);

    const [present] = useIonActionSheet();
    const [extraData, setExtraData] = useState([
      { label: `${options.userAccountType === OCCUPANT_TYPE ? "Tenant" : "Member"}`, value: tenantName },
      { label: "Property", value: propertyName },
      { label: "Unit", value: unitName },
      { label: "Date", value: invoiceDate },
      {label: "Items", value: invoice.item},
      { label: "Id/Number", value: invoiceId },
      { label: "Status", value: invoice.status },
      { label: "Amount", value: `${amount} ${currency}` },
      { label: "Description", value: invoice.description }
    ])

    const actionsRequiringAllInvoicePerms = [A_VIEW, A_DELETE]
    const actionsRequiringAllMsgPerms = [A_SEND]



    const open = async () => {
        const mode = getMode();
        const canEdit = userAllPerms.invoice;
        let iconToShow = canEdit ? pencil : eye;
        const buttons = [{
          text: canEdit ? A_EDIT : A_VIEW,
          role: 'destructive',
          icon: mode !== 'ios' ? iconToShow : '',
          handler: () => {
              handleInvoiceAction('edit', invoiceId);
          }
        }, {
          text: A_SEND,
          icon: mode !== 'ios' ? send : '',
          handler: () => {
            handleInvoiceAction('sendInvoice', invoiceId);
          }
        }, {
          text: A_DOWNLOAD,
          icon: mode !== 'ios' ? cloudDownload : '',
          handler: () => {
            handleInvoiceAction('downloadInvoice', invoiceId);
          }
        },
        {
          text: A_DELETE,
          icon: mode !== 'ios' ? trash : '',
          handler: () => {
            handleInvoiceAction('delete', invoiceId);
          }
        }, {
          text: A_CANCEL,
          role: 'cancel',
          icon: mode !== 'ios' ? close : '',
          handler: () => {}
        }];

        let filteredButtons = buttons;
        if(!userAllPerms.invoice){
          filteredButtons = filteredButtons.filter((b) => !actionsRequiringAllInvoicePerms.includes(b.text));
        }
        if(!userAllPerms.message){
          filteredButtons = filteredButtons.filter((b) => !actionsRequiringAllMsgPerms.includes(b.text));
        }

        present({
          header: tenantName + "  " + amount + " " + currency,
          buttons: filteredButtons
        });
      }

    useEffect(() => {
        setShowExtraDetails(showDetails);
    }, [showDetails])

    return (
        <div className='mx-1 mx-md-4' key={invoiceId}>
          <Row style={{width: '100%'}} className='my-2 mx-0 shadow-sm py-1 rounded'>
          <Row className='rounded mx-0 px-0'
          >
            <Col id='invoice-page-expand-details' onClick={ () => { setShowExtraDetails(!showExtraDetails)} } xs={8} md={6}>
              <Row>
              <Col xs={12} md={6}>
                <div className="d-flex align-items-center">
                  <strong>{tenantName}</strong>
                  <IonIcon
                    style={{fontSize: '20px', color: 'var(--ion-color-primary)', marginRight: '10px' }}
                    icon={!showExtraDetails ? chevronDownCircleOutline : chevronUpCircleOutline}
                  ></IonIcon>
                </div>
              </Col>

              <Col xs={12} md={6}>
                <IonNote className='text-sm md:text-base'>{unitName}{(unitName && propertyName)? " | ": ""}</IonNote> &nbsp;
                <IonNote className='text-sm md:text-base'>{propertyName}</IonNote>
              </Col>
              </Row>
            </Col>

            <Col className='mx-0 py-0' xs={3} md={5}>
              <Row>
              <Col className='px-0' xs={12} md={6}>
                <p>
                  <strong>{amount}</strong> &nbsp;
                  <IonBadge color="light">
                    <span className='text-sm md:text-base' style={{fontSize: '10px'}}>{currency}</span>
                  </IonBadge>
                </p>
              </Col>
              <Col className='px-0' xs={12} md={6}>
                <IonNote className='text-sm md:text-base'>{invoiceDate}</IonNote>
              </Col>
              </Row>
            </Col>

            <div style={{width: '25px', color: 'var(--ion-color-primary)'}} className='my-0 px-0 py-1 d-block d-md-none'>
                  <IonIcon onClick={open} size="large" aria-hidden="true"  icon={ellipsisVerticalSharp} />
            </div>
            <div style={{width: '50px', color: 'var(--ion-color-primary)'}} className='my-0 px-0 py-0 d-none d-md-block'>
                  <IonIcon id='invoice-page-menu-items' onClick={open} size="large" aria-hidden="true"  icon={ellipsisHorizontalSharp} />
            </div>
          </Row>

            {showExtraDetails && (<Row
              style={{backgroundColor: colorTheme["primary"]["25"] }}
              className='mx-0 px-0 mb-2 py-3 rounded tenant-list-row'>
              <Row>
                <IonButton 
                  fill="outline"
                  onClick={(e) => {
                    e.stopPropagation();
                    open();
                  }}
                >
                  Options
                </IonButton>
              </Row>
              { extraData.map((data, index) => (
                <Row key={index} className='border-bottom my-1 mx-1'>
                  <Col className='px-0' xs={4} md={3}><strong>{data.label}</strong></Col>
                  <Col xs={8} md={8}>
                    <span style={{fontSize: '16px'}}>{data.value}</span>
                  </Col>
                </Row>
              ))}
            </Row>)}
            </Row>
        </div>
    );
}

export default InvoiceListItem;